/**
 * Returns the API base URL for the current environment.
 * Reads REACT_APP_API_BASE env var first; falls back to smart dev/prod detection.
 * @returns {string}
 */
export const getApiBase = () => {
  if (process.env.REACT_APP_API_BASE) return process.env.REACT_APP_API_BASE;
  try {
    const { protocol, hostname, port } = window.location;
    const DEV_UI_PORTS = new Set(['3000', '5173']);
    if (DEV_UI_PORTS.has(String(port))) {
      return `${protocol}//${hostname}:5000`;
    }
    return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
  } catch {
    return 'http://localhost:5000';
  }
};

/**
 * Convert a relative backend path to an absolute URL.
 * If `u` is already absolute (starts with http/https), returns it unchanged.
 * @param {string} u
 * @returns {string}
 */
export const toBackendUrl = (u) => {
  if (!u) return '';
  if (/^https?:\/\//i.test(u)) return u;
  const isDev =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';
  const origin = isDev ? 'http://localhost:5000' : window.location.origin;
  return `${origin}${u.startsWith('/') ? u : `/${u}`}`;
};
